import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  notKnown: {
    id: 'report.details.notKnown',
    description: 'Not known',
    defaultMessage: 'Ei tiedossa',
  },
  years: {
    id: 'report.details.years',
    description: 'Years',
    defaultMessage: 'vuotta',
  },
  VATVisible: {
    id: 'report.details.VATVisible',
    description: 'VAT visible on receipt',
    defaultMessage: 'ALV kuitissa',
  },
  VATNotVisible: {
    id: 'report.details.VATNotVisible',
    description: 'VAT not visible on receipt',
    defaultMessage: 'ALV ei kuitissa',
  },
  notAvailable: {
    id: 'report.details.notAvailable',
    description: 'Not available',
    defaultMessage: 'Ei saatavilla',
  },
  hiredEmployees: {
    id: 'report.details.hiredEmployees',
    description: 'Hired employees',
    defaultMessage: 'Palkattuja työntekijöitä',
  },
  hiredEmployeesNotRegistered: {
    id: 'report.details.hiredEmployeesNotRegistered',
    description: 'Hired employees but not registered in employers register',
    defaultMessage:
      'Palkattuja työntekijöitä, mutta ei kuulu työnantajarekisteriin',
  },
  atMostTwoEmployees: {
    id: 'report.details.atMostTwoEmployees',
    description: 'At most two employees',
    defaultMessage: 'Korkeintaan 2 työntekijää',
  },
  cannotGetTaxPrepayment: {
    id: 'report.details.cannotGetTaxPrepayment',
    description: 'Cannot get tax prepayment (not in tax-prepayment register)',
    defaultMessage: 'Et saa kotitalousvähennystä (ei ennakkoperintärekisterissä)',
  },
  canGetTaxPrepayment: {
    id: 'report.details.canGetTaxPrepayment',
    description: 'Tax prepayment possible (in tax-prepayment register)',
    defaultMessage: 'Kotitalousvähennys mahdollinen (ennakkoperintärekisterissä)',
  },
  cannotGetTaxPrepaymentByOverride: {
    id: 'report.details.cannotGetTaxPrepaymentByOverride',
    description: 'Cannot get tax prepayment',
    defaultMessage: 'Et saa kotitalousvähennystä',
  },
  noAccidentInsuranceInfo: {
    id: 'report.details.noAccidentInsuranceInfo',
    description: 'No info about accident insurance',
    defaultMessage: 'Ei tietoa tapaturmavakuutuksesta',
  },
  noAccidentInsurance: {
    id: 'report.details.noAccidentInsurance',
    description: 'No accident insurance',
    defaultMessage: 'Ei tapaturmavakuutusta',
  },
  hasAccidentInsurance: {
    id: 'report.details.hasAccidentInsurance',
    description: 'Company has accident insurance',
    defaultMessage: 'Yrityksellä on tapaturmavakuutus',
  },
  noLiabilityInsuranceInfo: {
    id: 'report.details.noLiabilityInsuranceInfo',
    description: 'No info about liability insurance',
    defaultMessage: 'Ei tietoa vastuuvakuutuksesta',
  },
  noLiabilityInsurance: {
    id: 'report.details.noLiabilityInsurance',
    description: 'No liability insurance',
    defaultMessage: 'Yrityksellä ei ole vastuuvakuutusta',
  },
  hasLiabilityInsurance: {
    id: 'report.details.hasLiabilityInsurance',
    description: 'Company has liability insurance',
    defaultMessage: 'Yrityksellä on vastuuvakuutus',
  },
  homeElectricityInstallation: {
    id: 'report.details.homeElectricityInstallation',
    description: 'Home electricity installations',
    defaultMessage: 'Kodin sähkötyöt',
  },
});
